// pages/ApprovedUsersPage.jsx
import React, { useState } from 'react';
import {
  Box, Typography, Alert, IconButton,
  Table, TableHead, TableBody, TableRow, TableCell,
  TableContainer, Paper, Collapse, Chip
} from '@mui/material';
import {
  KeyboardArrowDown  as ArrowDownIcon,
  KeyboardArrowUp    as ArrowUpIcon,
  ArrowBack          as ArrowBackIcon
} from '@mui/icons-material';
import RouteIcon  from '@mui/icons-material/AltRoute';
import RoomIcon   from '@mui/icons-material/Room';
import { useLocation, Link as RouterLink } from 'react-router-dom';

/* helper – comma-separated route names */
const joinRoutes = routes =>
  routes.map(r => r.vehicleRoute.route_name).join(', ');

/* single table row with expandable detail */
function UserRow({ user }) {
  const [open, setOpen] = useState(false);
console.log("user",user);
  return (
    <>
      <TableRow hover>
        <TableCell padding="checkbox">
          <IconButton size="small" onClick={() => setOpen(!open)}>
            {open ? <ArrowUpIcon /> : <ArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>{user.studentName || '—'}</TableCell>
        <TableCell>{user.classSection || '—'}</TableCell>
        <TableCell>{user._id.userId}</TableCell>
        <TableCell>{user._id.status}</TableCell>
        <TableCell>{user.requesterName || '—'}</TableCell>
        <TableCell>{user.relation || '—'}</TableCell>
        <TableCell>{joinRoutes(user.routes)}</TableCell>
      </TableRow>

      {/* expandable detail */}
      <TableRow>
        <TableCell colSpan={8} sx={{ p: 0, border: 0 }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ px: 4, py: 1 }}>
              {user.routes.map((r, idx) => (
                <Box key={idx} sx={{ mb: .75 }}>
                  <RouteIcon fontSize="inherit" color="action" sx={{ mr: .75 }} />
                  <Typography variant="body2" component="span">
                    {r.vehicleRoute.route_name}
                    {r.vehicleRoute.alias_number && ` (${r.vehicleRoute.alias_number})`}
                  </Typography>
                  {r.pickupPoint && (
                    <>
                      <RoomIcon fontSize="inherit" color="disabled" sx={{ ml: 1, mr: .5 }} />
                      <Typography variant="caption" component="span">
                        {r.pickupPoint.pickup_name}
                      </Typography>
                    </>
                  )}
                </Box>
              ))}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

export default function ApprovedUsersPage() {
  /* data came via navigate() */
  const { state } = useLocation();
  const users     = state?.users ?? [];

  if (!users.length) {
    return <Alert severity="warning" sx={{ m: 2 }}>No data passed.</Alert>;
  }

  return (
    <Box sx={{ p: 2 }}>
      {/* back link */}
      <Typography
        component={RouterLink}
        to="/tracking-dashboard"
        color="primary"
        sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none', mb: 2 }}
      >
        <ArrowBackIcon fontSize="small" sx={{ mr: 0.5 }} /> Back to Dashboard
      </Typography>

      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Approved Users ({users.length})
      </Typography>

      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead sx={{ bgcolor: 'grey.100' }}>
            <TableRow>
              <TableCell />
              <TableCell>Student</TableCell>
              <TableCell>Class&nbsp;/&nbsp;Section</TableCell>
              <TableCell>User&nbsp;ID</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Requester</TableCell>
              <TableCell>Relation</TableCell>
              <TableCell>Routes&nbsp;(summary)</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {users.map(u => (
              <UserRow key={u._id.userId} user={u} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
